import { render } from "./PrepaidSimCards.vue?vue&type=template&id=7160b641"
import script from "./PrepaidSimCards.vue?vue&type=script&lang=js"
export * from "./PrepaidSimCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__